






























































































































import Vue from 'vue'

export default Vue.extend({
  props: {
    pwaAlertData: {
      type: Object
    }
  },
  data() {
    return {
      open: false,
      deviceName: '',
      browserName: '',
      isCopied: false
    }
  },
  beforeMount() {
    this.detectDevice()
    this.detectBrowser()
    this.checkPWACompatibility()
  },
  computed: {
    logo(): string {
      return this.$store.getters.logo
    },
    pageTitle(): string {
      return this.$store.getters.pageTitle
    }
  },
  methods: {
    detectDevice() {
      if (
        window.navigator.userAgent.toLocaleLowerCase().includes('iphone') ||
        window.navigator.userAgent.toLocaleLowerCase().includes('ipad')
      ) {
        this.deviceName = 'iphone'
      } else if (
        window.navigator.userAgent.toLocaleLowerCase().includes('android')
      ) {
        this.deviceName = 'android'
      } else {
        this.deviceName = ''
      }
    },
    detectBrowser() {
      if (
        window.navigator.userAgent.toLocaleLowerCase().includes('chrome') ||
        window.navigator.userAgent.toLocaleLowerCase().includes('crios')
      ) {
        this.browserName = 'chrome'
      } else if (
        window.navigator.userAgent.toLocaleLowerCase().includes('safari')
      ) {
        this.browserName = 'safari'
      } else {
        this.browserName = ''
      }
    },
    getModalPosition(pos) {
      switch (pos) {
        case 'bottom':
          return 'bottom-0 left-1/2 -translate-x-1/2'
        default:
          return 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'
      }
    },
    checkPWACompatibility() {
      if (!this.browserName || !this.deviceName) {
        return
      }

      if (!this.isAppInstalled()) {
        this.open = true
      }
    },
    isAppInstalled() {
      const isStandalone = window.matchMedia('(display-mode: standalone)')
        .matches
      if (document.referrer.startsWith('android-app://')) {
        return true
      } else if (navigator.standalone || isStandalone) {
        return true
      }
      return false
    },
    copyLinkToClipboard() {
      window.navigator.clipboard.writeText(window.location.href)
      this.isCopied = true
    },
    closeModal() {
      this.open = !this.open
    }
  }
})
